import { DEVICES } from '../../../common/dropdownConstants';

export const filters = () => ({
  device: {
    name: 'device',
    type: 'select',
    label: 'Device',
    validateSavedValue: true,
    checkifValueExists: true,
    options: () => DEVICES,
    value: 'all'
  }
});
